import { CURRENT_ERROR } from "../constants";

export function currentError(state = {}, action) {
  switch (action.type) {
    case CURRENT_ERROR:
      return action.error;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/reducers/ErrorReducers.js